import {
  DispatcherIframeComponent,
  menuIdRouteMappings,
  NavigationService,
} from 'sce-core';
import { map } from 'rxjs/operators';

const ALL_SHIPMENTS_MENU_ID = 'all_shipments';
const ALL_SHIPMENTS_ROUTE = '/home/shipment/all-shipments';

(menuIdRouteMappings as { [menuId: string]: string })[ALL_SHIPMENTS_MENU_ID] =
  ALL_SHIPMENTS_ROUTE;

function insertAllShipments(items: any[]): boolean {
  if (!Array.isArray(items)) {
    return false;
  }
  for (const item of items) {
    const children = item?.subMenuItems;
    if (!Array.isArray(children)) {
      continue;
    }
    const planningItem = children.find(
      child => child?.menuID === 'shpmnt_planning'
    );
    if (planningItem) {
      if (!children.some(child => child?.menuID === ALL_SHIPMENTS_MENU_ID)) {
        children.push({
          ...planningItem,
          menuID: ALL_SHIPMENTS_MENU_ID,
          displayValue: 'All Shipments',
          subMenuItems: null,
        });
      }
      return true;
    }
    if (insertAllShipments(children)) {
      return true;
    }
  }
  return false;
}

const iframeProto = DispatcherIframeComponent.prototype as any;
const originalIframeInit = iframeProto.ngOnInit;
iframeProto.ngOnInit = function () {
  const menuId = localStorage.getItem('menuId');
  if (menuId !== ALL_SHIPMENTS_MENU_ID) {
    originalIframeInit.call(this);
    return;
  }
  localStorage.setItem('menuId', 'shpmnt_planning');
  const sanitizer = this.sanitizer;
  const originalBypass = sanitizer?.bypassSecurityTrustResourceUrl?.bind(sanitizer);
  if (originalBypass) {
    sanitizer.bypassSecurityTrustResourceUrl = (url: string) => {
      const rewritten = typeof url === 'string'
        ? url.replace('/home/shipment/shipment-planning', ALL_SHIPMENTS_ROUTE)
        : url;
      return originalBypass(rewritten);
    };
  }
  try {
    originalIframeInit.call(this);
  } finally {
    if (originalBypass) {
      sanitizer.bypassSecurityTrustResourceUrl = originalBypass;
    }
    localStorage.setItem('menuId', ALL_SHIPMENTS_MENU_ID);
  }
  if (typeof this.url === 'string') {
    this.url = this.url.replace(
      '/home/shipment/shipment-planning',
      ALL_SHIPMENTS_ROUTE
    );
  }
};

const navigationProto = NavigationService.prototype as any;
const originalGetUserMenu = navigationProto.getUserMenu;
navigationProto.getUserMenu = function () {
  return originalGetUserMenu.call(this).pipe(
    map((menu: any) => {
      insertAllShipments(menu);
      const planningCrumbs = this.menuIdbreadcrumbsMapping?.['shpmnt_planning'];
      if (planningCrumbs && this.menuIdbreadcrumbsMapping) {
        const crumbs = planningCrumbs.map(item => ({ ...item }));
        crumbs[crumbs.length - 1] = {
          id: ALL_SHIPMENTS_MENU_ID,
          displayValue: 'All Shipments',
          route: ALL_SHIPMENTS_ROUTE,
        };
        this.menuIdbreadcrumbsMapping[ALL_SHIPMENTS_MENU_ID] = crumbs;
      }
      const routing = this.accessibleMenuRouting;
      if (routing?.menuRoutings && !routing.menuRoutings[ALL_SHIPMENTS_MENU_ID]) {
        routing.menuRoutings[ALL_SHIPMENTS_MENU_ID] = 'all-shipments';
        routing.routings = routing.routings || [];
        routing.routings.push('all-shipments');
      }
      return menu;
    })
  );
};
